<div class="material-page">
  
  <div class="mdc-layout-grid">
    
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-5-desktop">
        <div>
          <h1 class="mat-headline-3" i18n>Become a Listx Reseller</h1>
          <p i18n>
            Become a Listx Reseller and start earning by selling items from our inventory. Make money every time you sell something from our marketplace.
          </p>
        </div>
      </div>
      <div style="display: flex;align-items: center;justify-content: center;" class="picture mdc-layout-grid__cell mdc-layout-grid__cell--span-7-desktop">
        <div style="width: 220px; height: 220px;position: relative">
          <img-with-placeholder [placeholder]="'/sales-partner/sales-partner_placeholder.webp' | assetUrl">
            <img 
                 fullSizedImage
                 ngSrc="/sales-partner/sales-partner.webp" 
                 ngSrcset="1x, 2x" 
                 width="220" 
                 height="221"/>
          </img-with-placeholder>
        </div>
      </div>
    
      <div class="mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-4" i18n>How it works?</h2>
        <ol>
          <li i18n>Pick the items that you want to sell from our reseller inventory (<a routerLink="/" [queryParams]="{ q: 'EdasimüügiksListxLadu' }"
              class="mid-text"
              angulartics2On="click" 
              angularticsAction="Link Pressed"
              angularticsCategory="see inventory"
              angularticsLabel="see inventory">see inventory</a>).</li>
          <li i18n>Sell them online (Facebook, Yaga, personal online shop, ...), offline (friends, family or a box at a second hand shop) or however you wish.</li>
          <li i18n>We take care of shipping the items to your buyers. Just let us know the delivery details.</li>
          <li i18n>Earn a nice commission on every sale.</li>
        </ol>
      </div>
      
      <div class="mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-4" i18n>Why join?</h2>
        <ol>
          <li i18n>Work from home, whenever you wish.</li>
          <li i18n>No upfront costs and no risk.</li>
          <li i18n>This could become your main income stream.</li>
        </ol>
      </div>
      
      <div class="get-box-form mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-4" i18n>I’m interested! Tell me more!</h2>
        <p i18n>Drop us your contacts and we’ll be in touch.</p>
        <form *ngIf="!requestSent" [formGroup]="resellersRequestForm" (ngSubmit)="sendRequest()" style="display: flex; flex-direction: column">
          <div>
            <mat-form-field class="form-text-field">
              <mat-label i18n>Name</mat-label>
              <input matInput formControlName="name" required>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label i18n>Surname</mat-label>
              <input matInput formControlName="surname" required>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label i18n>Email</mat-label>
              <input matInput formControlName="email" required>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label i18n>Phone</mat-label>
              <input matInput formControlName="phone" required>
            </mat-form-field>
          </div>
                 
          <span>     
            <button 
              mat-raised-button 
              type="submit"
              color="accent" 
              angulartics2On="click"
              angularticsAction="Button Pressed"
              angularticsCategory="SUBMIT"
              angularticsLabel="SUBMIT"
              i18n>
              SUBMIT
            </button>
          </span>
        </form>
        <p *ngIf="requestSent" i18n>Thank you!</p>
      </div>
    </div>
  </div>
</div>